import React from 'react';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import validator from 'validator';
import { connect } from 'react-redux';

import FormElement from '../../../shared/form/FormElement';
import * as campaignVersionActions from '../../../../actions/admin/campaignVersionActions';
import * as globalMessageActions from '../../../../actions/globalMessageActions';
import ClientsDropbox from '../../../shared/dropbox/ClientsDropbox';
import CampaignDropbox from '../../../shared/dropbox/CampaignDropbox';
import RewardPoolDropbox from '../../../shared/dropbox/RewardPoolDropbox';
import common from './common';

@connect((store) => {
  return {
    loginCtx: store.loginCtx.loginCtx,
    campaignVersionObject: store.adminCampaignVersion.campaignVersionNew
  };
})
class CampaignVersionCreate extends React.Component {

  constructor(props) {
    super(props);

    this.flowTypeOptions = [
      { label: 'None', value: null },
      { label: 'Sharer Triggered Reward', value: 'sharer_triggered_reward' },
      { label: 'Friend Triggered Reward', value: 'friend_triggered_reward' },
      { label: 'Both Triggered Reward', value: 'both_triggered_reward' },
      { label: 'Advertisement', value: 'advertisement' },
      { label: 'Direct Reward', value:'direct_reward' },
      { label: 'Custom Flow', value: 'custom_flow' },
      { label: 'Marketplace Simple', value: 'mp_simple' },
      { label: 'Marketplace Promotion', value: 'mp_promotion' },
    ];

    const {
      campaignVersionDetails = {
        clientId:'',
        campaignId:'',
        name:'',
        alias: '',
        sourceTags: [],
        active: '',
        exposure: '',
        rewardPoolId: '',
        linkExpiryDays:'',
        privateLinkExpiryDays: '',
        mpOfferTitle: '',
        documentUrl: '',
        publicSharedUrlExpiresAt:'',
        privateSharedUrlExpiresAt:'',
        flowType:null,
        shopifyImgUrl: ''
      }
    } = props;

    this.state = {
      campaignVersionDetails,
      errors: {},
      displayErrorMessage: false,
      formSuccessfullySubmitted: false,
      client: null,
      campaign: null,
      sourceTag: null
    };

    this.onClientChange = this.onClientChange.bind(this);
    this.onCampaignChange = this.onCampaignChange.bind(this);
    this.onRewardPoolChange = this.onRewardPoolChange.bind(this);
  }

  onChange(name, {target}) {
    const {campaignVersionDetails} = this.state;
    _.set(campaignVersionDetails, name, target.value);
    this.setState({campaignVersionDetails});
  }

  componentWillUpdate(nextProps){
    if(this.props.campaignVersionObject !=nextProps.campaignVersionObject){
      if(_.get(nextProps,'campaignVersionObject.data')){
        this.props.dispatch(globalMessageActions.showMessage({
          type: 'error',
          message: 'Error: ' + nextProps.campaignVersionObject.data.message,
          timeout: 10000
        }));
      }
    }
  }

  onClientChange(e){
    this.setState({client: e.value});
    const {campaignVersionDetails} = this.state;
    _.set(campaignVersionDetails, 'clientId', e.value);
    _.set(campaignVersionDetails, 'campaignId', '');
    this.setState({campaignVersionDetails});
  }

  onCampaignChange(e){
    this.setState({campaign: e.value});
    const {campaignVersionDetails} = this.state;
    _.set(campaignVersionDetails, 'campaignId', e.value);
    this.setState({campaignVersionDetails});
  }

  onRewardPoolChange(e){
    this.setState({rewardPoolId: e.value});
    const {campaignVersionDetails} = this.state;
    _.set(campaignVersionDetails, 'rewardPoolId', e.value);
    this.setState({campaignVersionDetails});
  }

  onPublicSharedUrlExpiresAtChange(date){
    console.log(date.value);
    const {campaignVersionDetails} = this.state;
    _.set(campaignVersionDetails, 'publicSharedUrlExpiresAt', date.value);
    this.setState({campaignVersionDetails});
  }

  onPrivateSharedUrlExpiresAtChange(date){
    console.log(date.value);
    const {campaignVersionDetails} = this.state;
    _.set(campaignVersionDetails, 'privateSharedUrlExpiresAt', date.value);
    this.setState({campaignVersionDetails});
  }

  onSubmit(){
    this.setState({ displayErrorMessage: false });
    const {campaignVersionDetails,errors} = this.state;
    let checkErrors = false;

    this.validateForm();

    if( errors['linkExpiryDays'] ) {
      checkErrors = true;
      this.setState({displayErrorMessage: true});
      this.props.dispatch(globalMessageActions.showMessage({
        type: 'error',
        message: 'please enter a number of days over 0 and under 999',
        timeout: 10000
      }));
      return;
    }

    for( const key in errors ) {
      if( errors[key] ) {
        checkErrors = true;
        this.setState({displayErrorMessage: true});
        this.props.dispatch(globalMessageActions.showMessage({
          type: 'error',
          message: 'Please fill all the required',
          timeout: 10000
        }));
        break;
      }
    }
    const campaignVersionDetailsWithoutEmpty = _.pickBy(campaignVersionDetails, _.identity);

    if( !checkErrors ) {
      this.props.dispatch(campaignVersionActions.newCampaignVersion(campaignVersionDetailsWithoutEmpty))
        .then(created => browserHistory.push({ pathname: `/admin/campaignVersion/${created._id}` , state: { fromCreatePage: true } }));
    }
  }

  validateForm() {
    const { campaignVersionDetails, errors } = this.state;

    errors[ 'campaignId' ] = validator.isEmpty(campaignVersionDetails.clientId);
    errors[ 'campaignId' ] = validator.isEmpty(campaignVersionDetails.campaignId);
    errors[ 'name' ] = validator.isEmpty( campaignVersionDetails.name );
    errors[ 'exposure' ] = validator.isEmpty( campaignVersionDetails.exposure.toString() );
    errors[ 'active' ] = validator.isEmpty( campaignVersionDetails.active.toString() );
    errors[ 'alias' ] = validator.isEmpty( campaignVersionDetails.alias );
    errors[ 'linkExpiryDays' ] = (()=>{
      if (campaignVersionDetails.linkExpiryDays === ''){
        return true;
      }
      return !validator.isInt(campaignVersionDetails.linkExpiryDays,{min:1,max:999});
    }
    )();

    errors[ 'privateLinkExpiryDays' ] = (()=>{
      if (campaignVersionDetails.privateLinkExpiryDays === ''){
        return true;
      }
      return !validator.isInt(campaignVersionDetails.privateLinkExpiryDays+'',{min:-1,max:999});
    }
    )();

    return this.setState({ errors });
  }

  render (){

    const {campaignVersionDetails = { info: {} }, sourceTag, errors, displayErrorMessage } = this.state;

    const {
      campaignId,
      name,
      alias,
      sourceTags,
      active,
      exposure,
      rewardPoolId,
      linkExpiryDays,
      privateLinkExpiryDays,
      marketplaceOfferTitle,
      mpOfferTitle,
      documentUrl,
      trackingLink,
      affTrackingLinkOnLoad,
      publicSharedUrlExpiresAt,
      privateSharedUrlExpiresAt,
      shopifyImgUrl
    } = campaignVersionDetails;

    return (
      <div>
        <h3>Create campaign version</h3>
        <form  className="c-form--flex">

          <ClientsDropbox
            required='true'
            onChange={this.onClientChange}
            error={errors.clientId}
          />

          <CampaignDropbox
            required='true'
            client={this.state.client}
            onChange={this.onCampaignChange}
            error={errors.campaignId}
          />

          <FormElement
            label='Campaign Id'
            name='campaignId'
            type='text'
            onChange={this.onChange.bind(this, 'campaignId')}
            value={campaignId}
            error={errors.campaignId}
            id='form-campaignId'
            disabled
          />

          <FormElement
            label='Name'
            name='name'
            type='text'
            onChange={this.onChange.bind(this, 'name')}
            value={name}
            error={errors.name}
            id='form-name'
            required
          />

          <FormElement
            label='Active'
            name='active'
            type='select'
            onChange={this.onChange.bind(this, 'active')}
            value={active}
            error={errors.active}
            id='form-active'
            required
          >
            <option value=""> </option>
            <option value="true">true</option>
            <option value="false">false</option>
          </FormElement>

          <FormElement
            label='Exposure'
            name='exposure'
            type='text'
            onChange={this.onChange.bind(this, 'exposure')}
            value={exposure}
            error={errors.exposure}
            id='form-exposure'
            required
          />

          <RewardPoolDropbox
            required
            label='Reward Pool'
            client={this.state.client}
            onChange={this.onRewardPoolChange}
            error={errors.rewardPoolId}
            id='form-rewardpoolid'
          />
          <fieldset>
            <legend>Expiration</legend>

            <div className="ui-g">
              <div className="ui-g-12 ui-md-6 ui-lg-3">
                <FormElement
                  label='Public Links Expiration Absolute Date'
                  name='publicShareUrlExpiresAt'
                  type='calendarWithTime'
                  onChange={(e) => 
                    this.onPublicSharedUrlExpiresAtChange(e)
                  } 
                  value={ this.state.campaignVersionDetails.publicSharedUrlExpiresAt? new Date(this.state.campaignVersionDetails.publicSharedUrlExpiresAt) : ''}
                  id='start-date'
                  style={{ marginLeft: '5px', width: '200px' }}
                />
              </div>

              <div className="ui-g-12 ui-md-6 ui-lg-3">
                <FormElement
                  label='Private Links Expiration Absolute Date'
                  name='privateShareUrlExpiresAt'
                  type='calendarWithTime'
                  onChange={(e) => 
                    this.onPrivateSharedUrlExpiresAtChange(e)
                  } 
                  value={ this.state.campaignVersionDetails.privateSharedUrlExpiresAt? new Date(this.state.campaignVersionDetails.privateSharedUrlExpiresAt) : ''}
                  id='expiry'
                  style={{ marginLeft: '5px', width: '200px' }}
                />
              </div>

              <div className="ui-g-12 ui-md-6 ui-lg-3">
                <div className='daysExpiry'>
                  <FormElement
                    label='days until link expiry'
                    name='linkExpiryDays'
                    type='text'
                    onChange={this.onChange.bind(this, 'linkExpiryDays')}
                    value={linkExpiryDays}
                    error={errors.linkExpiryDays}
                    id='form-link-expiry-days'
                    required
                  />
                </div>
              </div>

              <div className="ui-g-12 ui-md-6 ui-lg-3">
                <div className='daysExpiry'>
                  <FormElement
                    label='days until private link expiry'
                    name='priviteLinkExpiryDays'
                    type='text'
                    onChange={this.onChange.bind(this, 'privateLinkExpiryDays')}
                    value={privateLinkExpiryDays}
                    error={errors.priviteLinkExpiryDays}
                    id='form-private-link-expiry-days'
                    required
                  />
                  <div class="tooltip"><i class="fa fa-question-circle" aria-hidden="true"></i>
                    <span class="tooltiptext">
                    The Shared Url will expire according to the <b> Absolute Date</b> or <b> Days until link expiry</b>. 
                      The closest expiration date will be considered. The absolute date can be null, so only <b> Days until link expiry</b> will be considered. 
                      <b> Days until link expiry</b> is calculated from the Shared Url creation’s date.
                      <b>Public links</b> are the ones generated during the sharing process. <b>Private links</b> are the ones generated for a single targeted person.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          <FormElement
            label='Marketplace Offer Title'
            name='mpOfferTitle'
            type='text'
            onChange={this.onChange.bind(this, 'mpOfferTitle')}
            value={mpOfferTitle}
            id='form-marketplace-offer-title'
          />
          
          <FormElement
            label='Document URL'
            name='documentUrl'
            type='text'
            onChange={this.onChange.bind(this, 'documentUrl')}
            value={documentUrl}
            id='form-document-url'
          />

          <FormElement
            label='Tracking Link'
            name='trackingLink'
            type='text'
            onChange={this.onChange.bind(this, 'trackingLink')}
            value={trackingLink}
            id='tracking-link'
          />

          <div className='affTrackingLinkOnLoad'>
            <FormElement
              label='Affiliate Tracking Link on Landing Page Load'
              name='affTrackingLinkOnLoad'
              type='text'
              onChange={this.onChange.bind(this, 'affTrackingLinkOnLoad')}
              value={affTrackingLinkOnLoad}
              id='affTrackingLinkOnLoad'
            />
            <div class="tooltip"><i class="fa fa-question-circle" aria-hidden="true"></i>
              <span class="tooltiptext">This tracking link is used by the landing page on its automatic redirection process on load. The user has no access to this link. This value must implement 2 dynamic values, <b>{'{sua_id}'}</b> to the click identification and <b>{'{red_url}'}</b> to the callback url
              </span>
            </div>
          </div>

          <FormElement
            label='Shopify image URL'
            name='shopifyImgUrl'
            type='text'
            onChange={this.onChange.bind(this, 'shopifyImgUrl')}
            value={shopifyImgUrl}
            id='tracking-link'
          />

          <FormElement
            label='Source Tag'
            name='sourceTag'
            type='text'
            onChange={ (e) => {  
              if(e.target.fromSugestion){ 
                common.addTagOption(this, e.target.value) ;
              } else { 
                this.setState({sourceTag : e.target.value}); 
              }
            }}
            onKeyPress={(e) => { if(e.key == 'Enter'){  common.addTagOption(this, sourceTag); } }}
            value={sourceTag}
            error={errors.sourceTag}
            id='form-source-tag'
            fillingOptions={['CONFIRMATION_PAGE', 'STATIC_PAGE_ON_SORETO', 'STATIC_PAGE_ON_CLIENT']}>
     
          </FormElement> 

          <div>
            { common.sourceTagOptions(this, sourceTags) }
          </div>

          <FormElement
            label='Flow Type'
            name='flowType'
            type='dropdown'
            onChange={(e) => { 
              const { campaignVersionDetails } = this.state;
              _.set(campaignVersionDetails, 'flowType', e.value);
              this.setState({campaignVersionDetails});
            }}
            value={this.state.campaignVersionDetails.flowType}
            style={{ marginLeft: '5px', width:'300px' }} 
            error={errors.flowType}
            options={this.flowTypeOptions}
            id='type'
          />

          <FormElement
            label='Alias'
            name='alias'
            type='text'
            onChange={this.onChange.bind(this, 'alias')}
            value={alias}
            error={errors.alias}
            id='form-alias'
            required
          />

        </form>
        <br />
        <button style={{ marginTop: '10px' }} onClick={()=>this.onSubmit()}>Create</button>

        <button
          className="button icon-left"
          onClick={browserHistory.goBack}>
          Back
        </button>
      </div>
    );
  }
}

export default CampaignVersionCreate;
